// Configuración del paso "Placas" — réplica del paso "Seguros".

export const STEP_TYPE = 'register_plates';
export const STEP_LABEL = 'Placas';
export const STEP_ICON = 'pi pi-car';

export const PLATE_STATE_OPTIONS = [
  { value: 'CDMX',    label: 'CDMX' },
  { value: 'EDOMEX',  label: 'EDOMEX' },
  { value: 'Morelos', label: 'Morelos' },
];

export const FUEL_OPTIONS = [
  { value: 'Gasolina',  label: 'Gasolina' },
  { value: 'Diésel',    label: 'Diésel' },
  { value: 'Eléctrico', label: 'Eléctrico' },
  { value: 'Híbrido',   label: 'Híbrido' },
];

export const VEHICLE_USE_OPTIONS = [
  { value: 'Particular', label: 'Particular' },
  { value: 'Carga',      label: 'Carga' },
  { value: 'Pasaje',     label: 'Pasaje' },
  { value: 'Oficial',    label: 'Oficial' },
];

export const VEHICLE_TYPE_OPTIONS = [
  { value: 'Auto',        label: 'Auto' },
  { value: 'Pickup',      label: 'Pickup' },
  { value: 'Motocicleta', label: 'Motocicleta' },
  { value: 'Otro',        label: 'Otro' },
];

// Amolda CUALQUIER valor de tipo de vehículo (crudo del documento, de versiones
// viejas del prompt, sinónimos, mayúsculas/acentos) a una de las opciones válidas
// del Select. Regla de negocio: "camioneta" = Pickup (incluye SUV / todo terreno).
// Devuelve '' si no hay valor; 'Otro' si hay valor pero no mapea a Auto/Pickup/Moto.
export function normalizeVehicleType(raw) {
  if (raw == null) return '';
  const s = String(raw).trim().toLowerCase();
  if (!s) return '';
  // Pickup primero: gana sobre "automovil" cuando viene "AUTOMOVIL SUV".
  if (/pick.?up|camioneta|\bsuv\b|todo.?terreno|doble cabina|cabina sencilla|chasis cabina/.test(s)) return 'Pickup';
  if (/moto|motocicleta|motoneta|scooter/.test(s)) return 'Motocicleta';
  if (/auto|autom[oó]vil|sed[aá]n|hatchback|coup|berlina|convertible|vagoneta/.test(s)) return 'Auto';
  return 'Otro';
}

export const CANCEL_REASONS = [
  { value: 'cliente_baja',    label: 'Cliente solicita baja' },
  { value: 'cambio_placa',    label: 'Cambio de placa' },
  { value: 'robo_vehiculo',   label: 'Robo del vehículo' },
  { value: 'siniestro_total', label: 'Siniestro total' },
  { value: 'error_tramite',   label: 'Error en el trámite' },
  { value: 'otro',            label: 'Otro' },
];

export const REJECT_REASONS = [
  { value: 'vin_no_coincide',          label: 'VIN no coincide' },
  { value: 'estado_equivocado',        label: 'Estado equivocado' },
  { value: 'tarjeta_vencida_origen',   label: 'Tarjeta vencida en origen' },
  { value: 'documentacion_falta',      label: 'Falta documentación' },
  { value: 'otro',                     label: 'Otro' },
];

// Convierte un código de motivo (cancel o reject) en su etiqueta legible.
// Si no lo encuentra, formatea el código (snake_case → "Snake case").
export function reasonLabel(code) {
  if (!code) return '';
  const found = [...CANCEL_REASONS, ...REJECT_REASONS].find((r) => r.value === code);
  if (found) return found.label;
  return String(code).replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());
}

// Etiquetas humanas para los event_type que vienen del backend.
export const EVENT_LABELS = {
  created:            { label: 'Paso completado',     icon: 'pi-check-circle',  color: 'green'  },
  email_sent:         { label: 'Correo enviado',      icon: 'pi-send',          color: 'cyan'   },
  document_uploaded:  { label: 'Documento subido',    icon: 'pi-cloud-upload',  color: 'cyan'   },
  ai_extracted:       { label: 'IA extrajo datos',    icon: 'pi-sparkles',      color: 'orange' },
  corrected:          { label: 'Corrección aplicada', icon: 'pi-pencil',        color: 'blue'   },
  policy_amended:     { label: 'Placa modificada',    icon: 'pi-pencil',        color: 'blue'   },
  cancelled:          { label: 'Placa cancelada',     icon: 'pi-ban',           color: 'red'    },
  renewed:            { label: 'Placa renovada',      icon: 'pi-refresh',       color: 'green'  },
  reopened:           { label: 'Paso reabierto',      icon: 'pi-replay',        color: 'blue'   },
  provider_rejected:  { label: 'Gestor rechazó',      icon: 'pi-times-circle',  color: 'red'    },
  note:               { label: 'Nota',                icon: 'pi-comment',       color: 'cyan'   },
};

export function mapPlateStepStatus(step, plate) {
  // Mapea status del backend a estados de la UI
  if (!step) return 'pending';
  if (step.status === 'unsuccessful') return 'rejected';
  if (step.status === 'completed' && plate?.status === 'cancelled') return 'cancelled';
  if (step.status === 'completed') return 'completed';
  if (step.status === 'in-progress') return 'sent';
  return 'pending';
}
